"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyExchangeRateResponseSchema = exports.DailyExchangeRateSchema = exports.ExchangeRatesSchema = exports.DailyExchangeRateQuerySchema = exports.SingleExchangeRateResponseSchema = exports.SingleExchangeRateQuerySchema = exports.ExchangeRateSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
exports.ExchangeRateSchema = typebox_1.Type.Number({
    title: "Exchange Rate",
    minimum: 0,
});
exports.SingleExchangeRateQuerySchema = (0, core_1.StrictObject)({
    in: core_1.CurrencySchema,
    out: core_1.CurrencySchema,
    timestamp: typebox_1.Type.Optional(core_1.TimestampSchema),
});
exports.SingleExchangeRateResponseSchema = (0, core_1.StrictObject)({
    in: core_1.CurrencySchema,
    out: core_1.CurrencySchema,
    timestamp: typebox_1.Type.Optional(core_1.TimestampSchema),
    rate: exports.ExchangeRateSchema,
});
exports.DailyExchangeRateQuerySchema = (0, core_1.StrictObject)({
    from: core_1.TimestampSchema,
    to: core_1.TimestampSchema,
});
exports.ExchangeRatesSchema = typebox_1.Type.Record(core_1.CurrencySchema, exports.ExchangeRateSchema);
exports.DailyExchangeRateSchema = (0, core_1.StrictObject)({
    date: typebox_1.Type.String({ format: "date" }),
    rates: exports.ExchangeRatesSchema,
});
exports.DailyExchangeRateResponseSchema = (0, core_1.StrictObject)({
    base: core_1.CurrencySchema,
    rates: typebox_1.Type.Array(exports.DailyExchangeRateSchema),
});
